import React from "react";
import "./App.css";
import MainComponent from "./components/MainComponent";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <MainComponent />
    </div>
  );
}

export default App;
